import { PATH_REGEX_PATTERN } from './constants';
/**
 * Parses locale from the path
 *
 * @param {?string} [path] - Path
 * @return {?LocaleInfo} - Locale info if the pattern is matched. Otherwise, null is retrieved.
 *
 * @example
 * // returns { locale: 'en_gb', lang: 'en', country: 'gb', separator: '_' }
 * parseLocaleFromPath('https://www2.hm.com/en_gb/index.html')
 */
const parseLocaleFromPath = (path) => { var _a; return ((_a = path === null || path === void 0 ? void 0 : path.match(PATH_REGEX_PATTERN)) === null || _a === void 0 ? void 0 : _a.groups) || null; };
export default parseLocaleFromPath;
//# sourceMappingURL=parseLocaleFromPath.js.map